import React from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

// Redux
import { pingContent } from 'app/state/modules/content'

// Utils
import analytics from 'app/views/utils/analytics'
import LessonSteps from 'app/views/components/LessonSteps'


class Article extends React.Component {
  componentDidMount() {
    analytics.page('article')

    this.pingInterval = setInterval(() => {
      if (document.hasFocus()) {
        this.props.pingContent(this.props.match.params.id)
      }
    }, 5000)
  }

  componentWillUnmount() {
    if (this.pingInterval) {
      clearInterval(this.pingInterval)
    }
  }

  render() {
    const { content } = this.props
    return (
      <>
        <div>
          <div style={{ height: 150 }} className="uk-cover-container uk-background-secondary uk-padding-large uk-padding-remove-bottom uk-padding-remove-top uk-light">
            <div className="uk-section uk-padding-remove">
              <div className="uk-text-center uk-margin-top">
                <h2>{content.title}</h2>
                <h4 className="uk-margin-remove-top">
                  {content.description}
                </h4>
              </div>
            </div>
          </div>

          <div
            className="uk-container uk-container-small"
            data-uk-height-viewport="offset-top: true;"
          >
            <div className="uk-section uk-position-relative" style={{ paddingTop: 20 }} ref={(ref) => { this.lessonStepContainer = ref }}>
              <LessonSteps
                lessonStepContainerRef={this.lessonStepContainer}
                onClickBack={(stepIndex) => { this.props.handleClickBack(stepIndex) }}
                onClickCircle={(stepIndex) => { this.props.handleClickCircle(stepIndex) }}
                onClickDone={(stepIndex) => { this.props.handleClickDone(stepIndex) }}
                onClickNext={(stepIndex) => { this.props.handleClickNext(stepIndex) }}
                steps={content.steps}
                lessonCompletionURL="/"
                email=""
                title={content.title}
                description={content.description}
                lessonCompletionText="Next Lesson"
                contentId={content.uuid}
                currentProgress={content.current_progress}
                hasTest={content.has_test}
                contentType="article"
                userId={this.props.userId}
                idToken={this.props.idToken}
                codeSubmissions={[]}
              />
            </div>
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = ({ auth, hacker }) => ({
  idToken: auth.user.idToken,
  userId: hacker.profile.user_id,
})

export default withRouter(connect(mapStateToProps, {
  pingContent,
})(Article))
